import { ReactNode } from 'react';
import { IPageInfo } from '../../../../models/page.types';

export type ExaminerIndividualBlockingLimitsSortById = 'name' | 'examinerNumber' | 'limitType';

export enum ExaminerIndividualBlockingLimitsSortBy {
  Name = 1,
  ExaminerNumber,
  LimitType,
}

export const translateLimitsSortByIdToLimitsSortBy = (
  id: ExaminerIndividualBlockingLimitsSortById,
): ExaminerIndividualBlockingLimitsSortBy => {
  switch (id) {
    case 'name':
      return ExaminerIndividualBlockingLimitsSortBy.Name;
    case 'examinerNumber':
      return ExaminerIndividualBlockingLimitsSortBy.ExaminerNumber;
    case 'limitType':
      return ExaminerIndividualBlockingLimitsSortBy.LimitType;
    default:
      return ExaminerIndividualBlockingLimitsSortBy.Name;
  }
};

export interface ExaminerIndividualBlockingLimitsTableItem {
  [key: string]: string | number | JSX.Element | ReactNode;
  name: string;
  examinerPermissionId: string;
  examinerNumber: string;
  limit: string;
  totalLimitOutOfTolerance: number | string;
  sequentialLimitOutOfTolerance: number | string;
  totalLimitWithinTolerance: number | string;
  sequentialLimitWithinTolerance: number | string;
  actions: JSX.Element;
  inactiveProcessBadge?: ReactNode;
}

export interface ExaminerIndividualBlockingLimits {
  blockingLimitsType: LimitType;
  examinerBlockingLimitsId: string;
  examinerNumber: string;
  examinerPermissionId: string;
  firstName: string;
  lastName: string;
  totalLimitOutOfTolerance: number | null;
  sequentialLimitOutOfTolerance: number | null;
  totalLimitWithinTolerance: number | null;
  sequentialLimitWithinTolerance: number | null;
}

export interface ExaminerIndividualBlockingLimitsFilter {
  name: string;
  examinerNumber: string;
  limits: LimitType[];
}

export interface ExaminerIndividualBlockingLimitsFilterElements {
  limit: JSX.Element;
}

export enum LimitType {
  globalLimit = 1,
  individualLimit,
}

export interface ExaminerIndividualBlockingLimitsResponse {
  examinerBlockingLimits: ExaminerIndividualBlockingLimits[];
  page: IPageInfo;
}
